export default {
  ADDED_CROP: "addedCrop",
  ADDED_PATCH: "addedPatch",
  AUTO_FILL_FINISHED: "autoFillFinished",
  DESELECT_ALL: "deselectAll",
  ENABLE_TRANSFORMATION: "enableTransformation",
  ERROR: "error",
  INITIALIZED: "initialized",
  LOG: "log",
  MAGIC_ERROR: "magicError",
  MAGIC_WARNING: "magicWarning",
  RECEIVE_DATA: "receiveData",
  REMOVE_SELECTION: "removeSelection",
  SELECT_PLANT: "selectPlant",
  SELECT_DECORATION: "selectDecoration",
  TRANSFORM: "transform",
  UNDO_REDO_STATUS: "undoRedoStatus",
  UPDATE_GARDEN_SUNLIGHT: "updateGardenSunlight",
  UPDATE_PATCH_SUNLIGHT: "updatePatchSunlight",
  UPDATE_TOTAL_AREA: "updateTotalArea",
  ZOOM_LEVEL: "zoomLevel",
  WARN: "warn",
};
